var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAccountIdEnabled
    ? _c(
        "div",
        { staticClass: "emd-panel__section eu-my_5" },
        [
          _c(
            "emd-text",
            {
              staticClass:
                "emd-panel__block eu-display_flex eu-align-items_center_md",
              attrs: { tag: "h2" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("keys.id")) + " ")]
          ),
          _c("copy-clipboard", {
            staticClass: "emd-panel__block eu-basis_4_md eu-basis_2_lg",
            attrs: { copiable: _vm.account.id },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }